// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"172a33f3","134":"0e0c9817","300":"4c98d2b5","406":"621b9a07","453":"a9304c40","533":"2d352cf0","544":"f4d94c0f","642":"d3ec9564","671":"bad26cb0","984":"471e452d"}[chunkId] + ".chunk.js";
};